/**
 * ScrollToBottomButton
 *
 * Floating button that appears when user scrolls up in the thread.
 */

import { ChevronDownIcon } from '@heroicons/react/24/outline';

export default function ScrollToBottomButton({ onClick, unreadBelow = 0 }) {
  return (
    <div className="absolute bottom-24 right-8 z-10">
      <button
        className="btn btn-circle btn-sm bg-base-100 shadow-lg border border-base-300"
        onClick={onClick}
      >
        <ChevronDownIcon className="w-4 h-4" />
      </button>
      {unreadBelow > 0 && (
        <span className="absolute -top-1 -right-1 badge badge-primary badge-xs">
          {unreadBelow}
        </span>
      )}
    </div>
  );
}
